// extracted by mini-css-extract-plugin
module.exports = {"webviewMarginTop":"tabcustom_webviewMarginTop__Xt_J4","webview":"tabcustom_webview__WDncF"};